import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { kebabCase, upperCase } from 'lodash';
import PagingHeaderSortLink from './pagingHeaderSortLink';
import Icon from '../containers/icon';
import useLookup from '../../../utils/useLookup';
const PagingHeader = ({
  name: incomingName,
  indexQuery: {
    sort,
    sortDirection,
    sortAttribute
  },
  attributeMap,
  sortBy,
  hideSortOptions
}) => {
  const name = useLookup(incomingName);
  const caret = useMemo(() => {
    const convertDirectionToCaret = direction => {
      if (typeof direction === 'string') {
        if (upperCase(direction) === 'ASC') {
          return /*#__PURE__*/React.createElement(Icon, {
            glyph: "sort-up",
            "data-testid": "asc-sort-icon"
          });
        }
        return /*#__PURE__*/React.createElement(Icon, {
          glyph: "sort-down",
          "data-testid": "desc-sort-icon"
        });
      }
      return null;
    };
    // configurable cabinets store sorting in `sort` parameter
    if (Array.isArray(sort) && sort.length > 0
    // need to reverse lookup from the attribute to the headerName
    && sort[0].direction !== null && attributeMap[name] === sort[0].index) {
      return convertDirectionToCaret(sort[0].direction);
    }

    // old school sorting:
    // need to reverse lookup from the attribute to the headerName
    if (sortAttribute !== null && sortDirection !== null && attributeMap[name] === sortAttribute) {
      return convertDirectionToCaret(sortDirection);
    }

    // if the attribute is not in the attribute map, don't show the sort icon
    if (!attributeMap[name]) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Icon, {
      glyph: "sort",
      style: {
        opacity: 0.3
      },
      "data-testid": "sort-icon"
    });
  }, [attributeMap, name, sort, sortAttribute, sortDirection]);
  if (hideSortOptions || name && name.type && name.type === 'input' // do not sort checkboxes
  || typeof name !== 'string' // non-string nodes are presentation-only; no sort link
  ) {
    const nodeKey = typeof name === 'string' ? name : 'custom-header';
    return /*#__PURE__*/React.createElement("th", {
      key: nodeKey
    }, name);
  }
  return /*#__PURE__*/React.createElement("th", {
    key: name,
    "data-testid": `paging-header-${kebabCase(name)}`
  }, /*#__PURE__*/React.createElement(PagingHeaderSortLink, {
    name: name,
    onClick: sortBy,
    style: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, name, " ", caret));
};
PagingHeader.propTypes = {
  indexQuery: PropTypes.shape({
    sortDirection: PropTypes.string,
    sortAttribute: PropTypes.string,
    sort: PropTypes.arrayOf(PropTypes.shape({
      direction: PropTypes.string,
      index: PropTypes.string
    }))
  }).isRequired,
  attributeMap: PropTypes.shape({}).isRequired,
  hideSortOptions: PropTypes.bool.isRequired,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  sortBy: PropTypes.func.isRequired
};
export default PagingHeader;